import {
  IDENTITY_INFO_SUBMIT_FAIL,
  IDENTITY_INFO_SUBMIT_RESET,
  IDENTITY_INFO_SUBMIT_START,
  IDENTITY_INFO_SUBMIT_SUCCESS
} from "../constants/identityInfo";
import {IdentityInfoActions, IdentityInfoState} from "../types/identityInfo";

const initialState: IdentityInfoState = {
  submit: {
    loading: false,
    data: false,
    error: undefined,
  }
}

const reducer = (
  state = initialState,
  action: IdentityInfoActions,
): IdentityInfoState => {
  switch (action.type) {
    case IDENTITY_INFO_SUBMIT_START:
      return {
        ...state,
        submit: {
          ...initialState.submit,
          loading: true,
        }
      }
    case IDENTITY_INFO_SUBMIT_SUCCESS:
      return {
        ...state,
        submit: {
          ...state.submit,
          loading: false,
          data: action.payload,
        }
      }
    case IDENTITY_INFO_SUBMIT_FAIL:
      return {
        ...state,
        submit: {
          ...state.submit,
          loading: false,
          error: action.error,
        }
      }
    case IDENTITY_INFO_SUBMIT_RESET:
      return {
        ...state,
        submit: {
          ...initialState.submit,
        }
      }
    default:
      return state;
  }
}

export default reducer;
